import React from "react";
import { Box, Grid, makeStyles } from "@material-ui/core";

import EstimatedSalesMix from "./EstimatedSalesMix";
import OptimisedSalesMix from "./OptimisedSalesMix";
import PercentageSalesMixTitle from "./PercentageSalesMixTitle";
import ProductCategoryFilter from "./ProductCategoryFilter";
import SalesByProduct from "./SalesByProduct";
import SalesByProductTitle from "./SalesByProductTitle";
import SalesMixTitle from "./SalesMixTitle";
import Sort from "./Sort";
import StoreSalesCategoryMix from "./StoreSalesCategoryMix";

const useStyles = makeStyles(theme => ({
    chartSortBtn: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "flex-end",
        height: theme.spacing(11)
    },
}));

const ProductMix: React.FC = () => {
    const classes = useStyles();

    return (
        <Grid container spacing={3}>
            <Grid item md={12}>
                <SalesMixTitle />
            </Grid>
            <Grid item md={6}>
                <ProductCategoryFilter />
            </Grid>
            <Grid item md={6} className={classes.chartSortBtn}>
                <Sort />
            </Grid>
            <Grid item md={12}>
                <StoreSalesCategoryMix />
            </Grid>
            <Grid item md={12}>
                <PercentageSalesMixTitle />
            </Grid>
            <Grid item md={12}>
                <EstimatedSalesMix />
            </Grid>
            <Grid item md={12}>
                <OptimisedSalesMix />
            </Grid>
            <Grid item md={12}>
                <SalesByProductTitle />
            </Grid>
            <Grid item md={12}>
                <Box display="flex" flexDirection="column" >
                    <Box flexGrow={1} width='100%' height={'60vh'} >
                        <SalesByProduct />
                    </Box>
                </Box>
            </Grid>
        </Grid>
    );
};

export default ProductMix;
